<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>carregando</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important" variant="warning"></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-row style="height:40vh;margin:0" class="welcome-picture">
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8" style="height:100%">
          <div class="language">
            <template>
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div>          
          <div class="welcome-overlay">
            <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>LOVER</h1>
            <p class="main-subtitle">feito por amantes de vinho – para amantes de vinho</p>
          </div> 
        </b-col>
      </b-row> 
      <b-row>
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8">
          <p class="w-title">Somos um grupo de apaixonados por vinho.</p>
          <p class="w-text">Nossa missão é melhorar a experiência digital do vinho de forma aberta e não comercial. Foi por isso que criamos o <b>WyneLover</b>.</p>
          <p class="w-text">Nesta primeira fase, estamos desenvolvendo uma trilogia de aplicações online interligadas: WyneMaker, WyneCellar e WyneTaster.</p>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynemaker.com"><b>www.wynemaker.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Para que os produtores de vinho compartilhem informações detalhadas sobre suas vinícolas e seus vinhos.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynecellar.com"><b>www.wynecellar.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Para que os amantes de vinho gerenciem e organizem suas adegas pessoais.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynetaster.com"><b>www.wynetaster.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Para organizar ou participar de eventos de degustação de vinhos e gerenciar suas notas de degustação.</p>
            </b-col>
          </b-row>

          <p class="w-text">Assim que a WyneDatabase estiver suficientemente populada por produtores que utilizam o aplicativo WyneMaker, pretendemos compartilhá-la com o mundo por meio de uma API aberta — para o benefício de amantes do vinho, profissionais e desenvolvedores.</p>
          
          <hr>

          <p class="w-title">Como você pode nos ajudar?</p>
          <p class="w-subtitle">Apoio ativo.</p>
          <p class="w-text">Estamos à procura de voluntários apaixonados com uma ampla variedade de habilidades para nos ajudar a concluir e promover o projeto:</p>
          <p class="w-text" style="margin:15px">&#9642; marketing e divulgação</p>
          <p class="w-text" style="margin:15px">&#9642; conhecimento sobre vinhos (regional ou geral)</p>
          <p class="w-text" style="margin:15px">&#9642; design web, UI/UX</p>
          <p class="w-text" style="margin:15px">&#9642; habilidades linguísticas e de comunicação em diferentes países</p>
          <p class="w-text" style="margin:15px">&#9642; contatos com produtores de vinho, associações de vinicultores e revistas especializadas</p>
          <p class="w-text">Se você se empolga com a ideia de moldar o futuro digital do vinho e quer fazer parte da nossa equipe de voluntários, adoraríamos ter você conosco.</p>
          <p class="w-text">Interessado em se tornar um <b>WyneBassador</b>?</p>
          <p class="w-text">Envie um e-mail para <b>admin@wynelover.com</b> e conte quais habilidades você pode oferecer para o projeto.</p>
          
          <p class="w-subtitle">Apoio passivo.</p>
          <p class="w-text">Estamos comprometidos em manter este projeto aberto e não comercial. Isso significa que dependemos totalmente de doações. Se você gosta do que estamos construindo e deseja nos apoiar, considere clicar no botão de doação abaixo.</p>

          <hr>

          <b-row>
            <b-col class="text-left">
              <b-button v-on:click="onBack()" class="w-button-pink">voltar</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button v-on:click="onDonate()" class="w-button-green">doar</b-button>
            </b-col>
          </b-row>
          <br>    
        </b-col>
      </b-row>
      <br>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WineryWelcome',
     computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },             
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false, 
        isLoading: true,
      }
    }, 
    mounted() {
      this.isLoading = false
    },
    methods: {
      onBack() {
        this.$router.push({path:'/Winery/'+this.previousPage, query: {winery_id:this.$route.query.winery_id }});
        this.$store.commit('setPage',this.previousPage)
      },
      onDonate() {
        window.open('https://www.paypal.com/donate/?hosted_button_id=968LLYKG8YBP6');
      },
      
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100vw;
    height:auto;
    
    background-image: url("../../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  width:100%;
  max-width: none !important; 
  position: relative;
  top: 10vh;
}

.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
  z-index: 10;
}
</style> 